export default __webpack_public_path__ + "static/media/eletric.ceec8a8f.png";